export enum StatoTask {
  'APERTO',
  'COMPLETATO',
}
